module.exports = __webpack_public_path__ + "static/media/22.b38f7ebe.wav";